export default __webpack_public_path__ + "static/PromptIconTwo-1f461bd5c39254822a0f4012fe5c3c87.png";